import 'reflect-metadata';

export { StuutApi } from './api';
export { AuthClient } from './auth';
export { QueryParams } from './query';
export type { LoginResponse, PortalMetricsResponse, Resource } from './resources';
export * from './types';

export { HttpError } from '@stuut/common/src/api_client';

import dayjs from 'dayjs';
import isBetween from 'dayjs/plugin/isBetween';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import relativeTime from 'dayjs/plugin/relativeTime';
import utc from 'dayjs/plugin/utc';

dayjs.extend(isBetween);
dayjs.extend(isSameOrAfter);
dayjs.extend(localizedFormat);
dayjs.extend(relativeTime);
dayjs.extend(utc);
